import React from 'react';
import Buttons from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Grid, Input } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';

class Title extends React.Component {

state = {
  changedDiscrepancies: [],
  load: false,
  message: '',
  error: '',
}

close() {
  this.setState({
    error: ''
  })
  this.props.handleClose();
}

onChange = (id, partno) => (f, { value }) => {
  let x = this.state.changedDiscrepancies;
  let b = false;
  x.map((temp) => {
    if (temp.id == id) {
      temp.discrepancy = value;
      b = true;
    }
  });
  if (b) {
    return;
  }
  x.push({id: id, partno: partno, branch: this.props.branch, discrepancy: value});
  this.setState({
    changedDiscrepancies: x,
    error: ''
  });
}

submit() {
  let context = this;

  let viewbound = this.state.viewbound;
  let data = this.state.changedDiscrepancies;
  if (data.length < 1) {
    context.setState({
      error: 'Enter the Discrepancy',
    })
  }
  let data2 = data;
  data = JSON.stringify(data);
  let data1 = { 'data': data };
  context.setState({
    load: true,
    message: 'Updating Discrepancy!!!',
  });
  $.ajax({
    type: 'POST',
    data: data1,
    url: Server() + 'stocktransfer/updatediscrepancy.php',
    success: function(data)
    {
      context.setState({
        load: false,
      });
      if (data == 1) {
        context.setState({
          changedDiscrepancies: [],
        });
        context.props.handleClose('yes');
      }
    },
    error: function(err)
    {
      context.setState({
        load: false,
      });
    }
  })
}

render() {
  let remarks = '';
  return (
    <div>
    <Loading load={this.state.load} message={this.state.message} />
    <Dialog open={this.props.openView} onClose={this.close.bind(this)}
      aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title" style={{width: 600}}>{"View Stock In"}</DialogTitle>
      <DialogContent>
        <table width='100%' id='table'>
          <tr>
            <th><center>Sino</center></th>
            <th><center>Part No</center></th>
            <th><center>Brand Name</center></th>
            <th><center>Stock</center></th>
            <th style={{display: 'none'}}><center>Shortage</center></th>
          </tr>
          {this.props.viewbound.map((z) => {
            remarks = z.remarks;
            let discrepancy = Number(z. discrepancy);
            return (
              <tr>
                <td><center>{z.sino}</center></td>
                <td><center>{z.partno+'->'+z.name}</center></td>
                <td><center>{z.brand_name}</center></td>
                <td><center>{z.stock}</center></td>
                <td style={{display: 'none'}}>
                  { (discrepancy > 0) ?
                    (
                      <div>{z.discrepancy}</div>
                    ):
                    (
                      <div>
                        <Input type='number' fluid focus id={z.id}
                        onChange={this.onChange(z.id, z.partno)} />
                      </div>
                    )
                  }

                </td>
              </tr>
            );
          }
          )}
        </table>
        { remarks.length >= 1 ?
          (<div>{'Remarks : '+remarks}</div>):
          (<div></div>)
        }
        <center style={{color: 'red', paddingTop: '1%'}}>{this.state.error}</center>
      </DialogContent>
      <DialogActions>
        <Buttons style={{display: 'none'}} onClick={this.submit.bind(this)}
          color="secoundary" autoFocus>
          Submit
        </Buttons>
        <Buttons onClick={this.close.bind(this)} color="secoundary" autoFocus>
          back
        </Buttons>
      </DialogActions>
    </Dialog>
    </div>
  );
}
}

export default Title;
